<!-- <div class="img">
  <img src="../../../assets/img/dev-map.svg" alt="map svg">
</div> -->
<!-- data-aos="fade-up"
data-aos-anchor-placement="bottom-bottom"
data-aos-duration="2000" -->
<!-- map section-->
<div class="overlay" >
  <div class="overlay-left">
    <div class="btn">
      <button class="btn-agent">
        <a href="https://dashboard.huiospay.com/registration/67a09908-6119-11ee-bfbe-7a0e4acd3f16" style="color: inherit; text-decoration: none;">
        Huiospay for developers
      </a></button>
    </div>
    <div class="bold-text">
      <h2>
        A completed all round API suite to create amazing payment experiences for your business
      </h2>
    </div>
    <div class="btn">
      <button class="btn-agent" (click)="becomeMerchantClick.emit()">
        Become POS Merchant
      </button>
    </div>
    <!-- <div class="btn">
      <button class="btn-agent"><a href="https://docs.google.com/document/d/1ZYwPrnXr7mgeahGQezqG63uP0lNOLwCM8SzLLbgTYGo/edit?tab=t.0#heading=h.6xcq3fjg48li" target="_blank" style="color: inherit; text-decoration: none;">
        Developer Docs
      </a></button>
    </div> -->
  </div>
</div>
<!--End  map section-->
